import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Sparkles } from "lucide-react";
import api from "@/lib/api";

const KEY = "eyfc_seen_release_id";

// One-time "What's new" pop-up shown after a release the user hasn't seen yet.
export function WhatsNewPopup() {
  const [release, setRelease] = useState(null);
  useEffect(() => {
    api.get("/releases").then(({ data }) => {
      const latest = data.releases?.[0];
      if (!latest) return;
      const seen = localStorage.getItem(KEY);
      if (seen === null) { localStorage.setItem(KEY, latest.id); return; }
      if (seen !== latest.id) setRelease(latest);
    }).catch(() => {});
  }, []);
  const dismiss = () => { if (release) localStorage.setItem(KEY, release.id); setRelease(null); };
  if (!release) return null;
  return (
    <Dialog open onOpenChange={v => { if (!v) dismiss(); }}>
      <DialogContent className="max-w-lg" data-testid="whats-new-popup">
        <DialogHeader>
          <DialogTitle className="font-display tracking-tight text-2xl flex items-center gap-2"><Sparkles className="w-5 h-5 text-[#83B68B]" /> What's new in v{release.version}</DialogTitle>
        </DialogHeader>
        <div className="text-sm font-semibold">{release.title}</div>
        <ul className="text-sm space-y-1.5 list-disc pl-5 opacity-90 max-h-[50vh] overflow-y-auto">
          {release.items.slice(0, 6).map((it, i) => <li key={i}>{it}</li>)}
          {release.items.length > 6 && <li className="opacity-60">…and {release.items.length - 6} more</li>}
        </ul>
        <div className="flex justify-between items-center pt-2">
          <Link to="/app/whats-new" onClick={dismiss} className="text-[10px] tracking-widest uppercase underline opacity-70 hover:opacity-100" data-testid="whats-new-popup-all">See all releases</Link>
          <button type="button" onClick={dismiss} data-testid="whats-new-popup-dismiss" className="btn-volt px-4 py-2 rounded text-[10px] tracking-widest uppercase">Got it</button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
